module.exports = __webpack_public_path__ + "static/media/dog-collar-tutorial.eb3153e9.mp4";